// js/helper/currency.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

const params = new URLSearchParams(window.location.search);
const utmPinId = params.get('utm_pin_id');

if (utmPinId) {
  if(utmPinId.includes('%2C') || utmPinId.includes(',')){
    const separator = utmPinId.includes('%2C') ? '%2C' : ',';
    const ids = utmPinId.split(separator);
    console.log(ids);

    var startOrder = -ids.length;
    for (var i = 0; i < ids.length; i++) {
      var order = startOrder + i;
      if ($('.product-card_main[data-pid="' + ids[i] + '"]').length > 0) {
        $('.product-card_main[data-pid="' + ids[i] + '"]').not('.hassold_out')
          .css('order', order)
          .addClass('ontop_pinned');
      }
    }
  }else{
    console.log('elslslsls')
    var pid = utmPinId;
    if($('.product-card_main[data-pid="'+pid+'"]').length > 0){
      $('.product-card_main[data-pid="'+pid+'"]').not('.hassold_out').attr('style','order: -1;').addClass('ontop_pinned');
    }
  }
  
}

const cartDrawer = document.querySelector("cart-drawer");

if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "open" &&
        cartDrawer.hasAttribute("open")
      ) {
        console.log("🛒 Cart drawer opened");

        setTimeout(() => {
          const $list = $(".cart-complementary-products__product-list");

          if ($list.length) {
            // destroy first if already slicked
            if ($list.hasClass("slick-initialized")) {
              $list.slick("unslick");
              console.log("♻️ Slick destroyed before reinit");
            }

            $list.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: true
            });

            console.log("✅ Slick re-initialized");
          } else {
            console.warn("⚠️ .cart-complementary-products__product-list not found");
          }
        }, 100); // delay after drawer opens
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });
}




window.addEventListener('load', function() {
  function initSwat() {
    if (window._swat && _swat.collectionsApi && typeof _swat.collectionsApi.initializeCollections === 'function') {
      console.log('wishlist icon added from custom.js');
      _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);
    } else {
      setTimeout(initSwat, 200); // check again after 200ms
    }
  }
  initSwat();
});


$(document).ready(function() {  
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.querySelector("cart-drawer").show();
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  $('.shop-purpose_row').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 699,
        settings: "unslick"
      }
    ]
  });
  $('.product-features_list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 1,
        }
      }
    ]
  });
  /* Not initialised below 700px, and that is a Core Web Vitals fix rather than a tidy-up.
   *
   * The config below shows 4 slides above 699 and "unslick" under it, so on a phone slick used to initialise,
   * restructure the DOM and then immediately tear itself down again. The round trip is what moved the page: during
   * the brief .slick-slider phase the `.explore-categories_row:not(.slick-slider) { display: flex }` rule in
   * theme.css stops matching, the items lose the flex row and become full-width blocks, and the row balloons into a
   * tall vertical stack before collapsing back.
   *
   * Measured on the live theme, emulated Moto G Power on Slow 4G, /collections/bestsellers:
   *
   *     DIV.explore-categories_row    0.4587  at 8.15s   <- 80% of the page's 0.5734 CLS
   *     announcement bar + main       0.1147  at 3.77s
   *
   * which is what fails the field assessment (CLS 0.48 mobile, LCP/FCP/TTFB all pass). Below 700 the end state IS
   * the un-slicked flex row, so skipping init lands on it directly and there is nothing left to shift.
   *
   * Trade-off: a desktop window dragged narrower than 700 now keeps the slider instead of unslicking. Resizing
   * across that breakpoint mid-session is rare next to every mobile visit paying the shift, and a reload restores
   * the right layout.
   */
  if (window.matchMedia('(min-width: 700px)').matches) {
    $('.explore-categories_row').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 699,
          settings: "unslick"
        }
      ]
    });
  }
  $('.everyday-inspiration_main').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          arrows: false,
          dots: false,
          infinite: true,
          slidesToShow: 1,
        }
      }
    ]
  });
  $('.half-image_grid-item.last .half-image_grid-item_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
  });

  const slier_arrow = $('.half-image-slider-list').attr('data-arrows') === 'true';
  const slide_duration = $('.half-image-slider-list').attr('data-duration');
  console.log('slide_duration',slide_duration);
  $('.half-image-slider-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: slier_arrow,
    dots: true,
    autoplay: true,
    autoplaySpeed: slide_duration, // wait 4 sec before next slide
    /* No `responsive` override. There used to be a `breakpoint: 699 -> arrows: false` entry here,
       which hard-disabled the prev/next arrows on mobile regardless of the section's own setting —
       so mweb got dots only. Arrows now follow "Show arrow" at every width, which leaves the
       store-details slider (show_arrow false) untouched and turns them on for A/W'26. */
  });

  /* Slide images link to their product (block.settings.link). slick fires a click on the anchor at the end
     of a swipe, so a drag would navigate; only treat it as a click when the pointer did not move. */
  $('.half-image-slider-list').each(function () {
    var moved = false;
    $(this)
      .on('mousedown.halfSliderLink touchstart.halfSliderLink', function () { moved = false; })
      .on('mousemove.halfSliderLink touchmove.halfSliderLink', function () { moved = true; })
      .on('click.halfSliderLink', 'a', function (e) {
        if (moved) { e.preventDefault(); }
      });
  });

  const slier_arrow2 = $('.store-media-gallery-list').attr('data-arrows') === 'true';
  const slide_duration2 = $('.store-media-gallery-list').attr('data-duration');
  const slide_auto2 = $('.store-media-gallery-list').attr('data-auto') === 'true';
  console.log('slide_duration',slide_duration);
  $('.store-media-gallery-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: slier_arrow2,
    dots: true,
    autoplay: slide_auto2,
    autoplaySpeed: slide_duration2, // wait 4 sec before next slide
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  $('.images_flex_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          dots: false,
          infinite: true,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 699,
        settings: {
          arrows: false,
          dots: false,
          infinite: true,
          slidesToShow: 1,
        }
      }
    ]
  });
  // $('.gyb-featured-collection-product-list').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   infinite: false,
  //   arrows: true,
  //   dots: false,
  //   responsive: [
  //     {
  //       breakpoint: 699,
  //       settings: {
  //         slidesToShow: 2,
  //         dots: true
  //       }
  //     }
  //   ]
  // });

  $('.cart-complementary-products__product-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
  });

  (function () {
    var sliderMobile = window.matchMedia('(max-width: 740px)').matches;

    $('.product-card__figure--slider').each(function () {
      var $slider = $(this);

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: sliderMobile,        // mobile: auto; desktop: off until hover
        pauseOnHover: false,
        pauseOnFocus: false
      });

      if (!sliderMobile) {
        $slider.on('mouseenter', function () {
          $slider.slick('slickPlay');
        });
        $slider.on('mouseleave', function () {
          $slider.slick('slickPause');
        });
      }
    });
  })();

  if ($(window).width() >= 1000) {
    $('.footer__block--links.full_width .footer__block--title').click(function () {
      $(this).toggleClass('active');
      $(this).next('.footer__block--links_main').slideToggle();
    });
  }else{  
    $('.footer__block--title').click(function(){
      $(this).toggleClass('active');
      $(this).next('.footer__block--links_main').slideToggle();
    })
  }
  $('.seo-read-more-less_link').click(function(e){
    e.preventDefault();
    if($(this).closest('.seo-content_text-wrapper').hasClass('active')){
      $(this).text('Read More').closest('.seo-content_text-wrapper').removeClass('active');
    }else{
      $(this).text('Read Less').closest('.seo-content_text-wrapper').addClass('active');
    }
  });
  $('.product-offers__item-title').click(function(){
   $(this).toggleClass('active'); 
   $(this).next('.product-offers__item-description').toggle();
  });

  $('.product-type-popup-button').click(function(){
    $('.similar-product-popup_overlay').addClass('active');
  });
  $('.product-type-popup-button-text_inner').click(function(){
    $('.similar-product-popup_overlay').addClass('active');
  });
  $('.similar-product-popup_close').click(function(){
    $('.similar-product-popup_overlay').removeClass('active');
  });
  if ($(window).scrollTop() > 1000) {
    $('.go-top').addClass('show');
  } else {
    $('.go-top').removeClass('show');
  }

  $('.go-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600); // 600 = speed in ms
  });

  $('.collection-hero_content-description-read_more').click(function(e) {
    e.preventDefault();
    $('.collection-hero_content-description').toggle();
    if ($('.collection-hero_content-description-read_more').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });

  $('.collection-hero_image-collumn-wrapper').on('click', function(e) {
    e.preventDefault();

    var rootStyles = getComputedStyle(document.documentElement);
    var headerheight = parseInt(rootStyles.getPropertyValue('--header-height')) || 0;
    var barHeight = parseInt(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
    var colltoolHeight = parseInt(rootStyles.getPropertyValue('--collection-toolbar-height')) || 0;

    if (window.matchMedia("(max-width: 768px)").matches) {
      console.log("Mobile screen");
      $('html, body').animate({
        scrollTop: $('.shopify-section--main-collection').offset().top-(headerheight + barHeight + 10)
      }, 600);
    } else {
      console.log("Desktop screen");
      $('html, body').animate({
        scrollTop: $('.shopify-section--main-collection').offset().top-(headerheight + barHeight)
      }, 600);
    }
  });

  $('body').on('click','.backpack-modal-openr', function(e){
   e.preventDefault();
   $('.backpack-modal-overlay').addClass('is-active');
   $('.backpack-modal').addClass('is-active');
   $('html').addClass('lock');
  });
  $('body').on('click','.backpack-modal_close', function(e){
   e.preventDefault();
   $('.backpack-modal-overlay').removeClass('is-active');
   $('.backpack-modal').removeClass('is-active');
   $('html').removeClass('lock');
  });

  $('body').on('click','a[href="#waitlistpopup"],[data-notify-me-btn]', function(e){
    e.preventDefault();
    $('.waitlist-overlay,.waitlist-popup').addClass('active');
    $('.waitlist-popup [createcustomerform] [custom-values]').remove();
    if($(this).attr('data-pid')){
      $('.waitlist-popup [createcustomerform]').prepend('<input type="hidden" custom-values data-key="notify_me_product_url" value="'+$(this).attr('data-pid')+'" />');
    }
  });
  $('body').on('click','.waitlist-popup .close_popup', function(e){
    e.preventDefault();
    $('.waitlist-overlay,.waitlist-popup').removeClass('active');
  });

  if($('[createCustomerForm]').length > 0){
   $('body').on('submit','[createCustomerForm]', function (e) {
    e.preventDefault();

    var _this = $(this);
    _this.find('.banner--success,.banner--error').remove();

    const name = _this.find('#name').val().trim();
    const email = _this.find('#email').val().trim();
    const phone = '91' + _this.find('#phone').val().trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{12,15}$/;

    if (!emailRegex.test(email)) {
      _this.append('<p class="banner--error">Please enter a valid email address.</p>');
      return;
    }

    if (!phoneRegex.test(phone)) {
      _this.append('<p class="banner--error">Please enter a valid 10 digit number without any space.</p>');
      return;
    }

    // ✅ MUST BE OBJECT
    var formdata = {};

    // ✅ Collect dynamic fields
    _this.find('[custom-values]').each(function(){
      const key = $(this).attr('data-key');
      const value = $(this).val();

      if (key && value) {
        formdata[key] = value;
      }
    });

    // ✅ Add main fields
    formdata.first_name = name;
    formdata.phone = phone;
    formdata.email = email;
    formdata.tag = 'Love Collection 2026';

    console.log("Final Payload:", formdata);

    $.ajax({
      url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
      method: "POST",
      contentType: "application/json",
      headers: {
        "Authorization": "970614a6802448fd87feb315a2fc121d"
      },
      data: JSON.stringify(formdata),
      success: function (response) {
        console.log(response);
        if (response.status == 1) {
          _this.append('<p class="banner--success">' + response.message + '</p>');
        } else {
          _this.append('<p class="banner--error">' + response.message + '</p>');
        }
      },

      error: function (xhr) {
        console.log(xhr);
        let msg = "Something went wrong!";
        if (xhr.responseJSON && xhr.responseJSON.message) {
          msg = xhr.responseJSON.message;
        }
        _this.append('<p class="banner--error">' + msg + '</p>');
      }
    });
  });
  }  

  if($('#backpack-timer').length){
    // Set the date we're counting down to
    var notify_countDownDate = new Date(`${$('#backpack-timer').attr('date')}`).getTime();
  
    // Update the count down every 1 second
    var notify_x = setInterval(function () {
      // Get today's date and time
      var notify_now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var notify_distance = notify_countDownDate - notify_now;
  
      // Time calculations for days, hours, minutes and seconds
      var notify_days = Math.floor(notify_distance / (1000 * 60 * 60 * 24));
      var notify_hours = Math.floor((notify_distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var notify_minutes = Math.floor((notify_distance % (1000 * 60 * 60)) / (1000 * 60));
      var notify_seconds = Math.floor((notify_distance % (1000 * 60)) / 1000);
  
      var notify_days_content = '',
        notify_hours_content = '',
        notify_minutes_content = '',
        notify_seconds_content = '';

      if (notify_countDownDate > notify_now) {
          $('.backpack-timer-text').show();
          if (notify_days > 0) {
            notify_days_content = `<div class="timer_item"><span class="timer_item-val"><span class="numval">${String(notify_days).padStart(2,'0')}</span>Days</span></div>`;
          }
          if (notify_hours > 0) {
            notify_hours_content = `<div class="timer_item"><span class="timer_item-val"><span class="numval">${String(notify_hours).padStart(2,'0')}</span>Hours</span></div>`;
          }
          notify_minutes_content = `<div class="timer_item"><span class="timer_item-val"><span class="numval">${String(notify_minutes).padStart(2,'0')}</span>Minutes</span></div>`;
          notify_seconds_content = `<div class="timer_item"><span class="timer_item-val"><span class="numval">${String(notify_seconds).padStart(2,'0')}</span>Seconds</span></div>`;
      }else {
        $('.backpack-timer-text').hide();
        $('#backpack-timer').hide();
      }

      // Display the result in the element with id="demo"
      $('.backpack-timer').each(function (index) {
        $(this).html(`
            ${notify_days_content}
            ${notify_hours_content}
            ${notify_minutes_content}
            ${notify_seconds_content}
          `);
      });
  
      // If the count down is finished, write some text
      if (notify_distance < 0) {
        clearInterval(x);
        console.log('innn')
        $('.timer_main-wrapper').hide();
        $('body').addClass('hide_timer');
      }
    }, 1000);
  }

  // $('body').on('click','[data-notify-me-btn]', function(e){
  //   e.preventDefault();
  //   $('.waitlist-overlay,.notifyme-popup').addClass('active');
  // });
  // $('body').on('click','.notifyme-popup .close_popup', function(e){
  //   e.preventDefault();
  //   $('.waitlist-overlay,.notifyme-popup').removeClass('active');
  // });

  // if($('[notifyme-createCustomerForm]').length > 0){
  //  $('body').on('submit','[notifyme-createCustomerForm]', function (e) {
  //     e.preventDefault(); // Prevent form submission
  //     var _this = $(this);
  //     _this.find('.banner--success,.banner--error').remove();
  //     const phone = '91'+_this.find('#phone').val();
  //     const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format

  //     // Basic Validation
  //     if (!phoneRegex.test(phone)) {
  //       _this.append('<p class="banner--error">Please enter a valid 10 digit number without any space.</p>');
  //       return;
  //     }

  //     var formdata = [];
  //     _this.closest('form').find('[custom-values]').each(function(){
  //       const key = $(this).attr('data-key'); // e.g. city, pincode
  //       const value = $(this).val();

  //       if (key && value) {
  //         formdata[key] = value; // 🔥 dynamically adding new key
  //       }
  //     });
  //     formdata['phone'] = phone;
  //     formdata['tag'] = 'Notify me';
  //     console.log(formdata);
  
  //     $.ajax({
  //       url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
  //       method: "POST",
  //       contentType:"application/json",
  //       headers: {
  //         "Authorization": "970614a6802448fd87feb315a2fc121d"
  //       },
  //       data: JSON.stringify(formdata),
  //       success: function (response) {
  //         console.log(response);
  //         if(response.status == 1){
  //           _this.append('<p class="banner--success">'+ response.message +'</p>');
  //         }else{
  //           _this.append('<p class="banner--error">'+ response.message +'</p>');
  //         }
          
  //       },
  //       error: function (xhr, status, error) {
  //         console.log(xhr, status, error);
  //         _this.append('<p class="banner--error">'+ xhr.response.message +'</p>');
  //       }
  //     });
                   
  //   }); 
  // }
   
// ============================================================================================

  $('.product-card__media-list_main').each(function () {
    var $wrapper = $(this);
    var $slider = $wrapper.find('.product-card__media-list');
    var $progressFill = $wrapper.find('.slick-progress-fill');
  
    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      var index = typeof currentSlide === 'undefined' ? 0 : currentSlide;
      var totalSlides = slick.slideCount;
      var percent = ((index + 1) / totalSlides) * 100;
  
      $progressFill.css('width', percent + '%');
    });
  
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            arrows: false,
            dots: false,
          }
        }
      ]
    });
  });


  /* A colour switch used to wait on a server round trip (~0.4s) for the other colour's card, and then on that card's
     image, before anything changed. Each colour's card markup is now fetched once and kept, ahead of the tap: when a
     card scrolls into view (a few KB of HTML per colour). Its main image is preloaded only on intent — hovering the
     card, or touching its swatch row — so scrolling a collection doesn't download every colour's photo. A switch then
     swaps straight from memory. Prefetched markup is parsed with DOMParser, which downloads nothing: parsing it into
     a live element would start every image in it at full-viewport size. */
  var cardSwapCache = {};
  var cardSwapImages = {};
  function fetchSwapCard(handle) {
    if (!cardSwapCache[handle]) {
      cardSwapCache[handle] = $.ajax({ type: 'GET', url: `/products/${handle}?view=product-card` });
      cardSwapCache[handle].fail(function() { delete cardSwapCache[handle]; });
    }
    return cardSwapCache[handle];
  }
  /* Gives `el` the attributes and children of `fresh`, except `kept` (a child of el), which stays mounted in the slot
     `freshKept` held. A mounted element keeps its hover state and can transition; a replacement starts from scratch. */
  function swapChildrenKeeping(el, fresh, kept, freshKept) {
    copyAttributes(el, fresh);
    Array.prototype.slice.call(el.childNodes).forEach(function(node) { if (node !== kept) node.remove(); });
    var beforeKept = !!kept;
    Array.prototype.slice.call(fresh.childNodes).forEach(function(node) {
      if (node === freshKept) { beforeKept = false; return; }
      if (beforeKept) el.insertBefore(node, kept); else el.appendChild(node);
    });
  }
  function copyAttributes(el, fresh) {
    Array.prototype.slice.call(el.attributes).forEach(function(attr) { if (!fresh.hasAttribute(attr.name)) el.removeAttribute(attr.name); });
    Array.prototype.slice.call(fresh.attributes).forEach(function(attr) { if (el.getAttribute(attr.name) !== attr.value) el.setAttribute(attr.name, attr.value); });
  }
  /* Moves the fresh row's state (selection, sold-out flags, colour name) onto the mounted row. False, with nothing
     touched, when the two rows list different colours, so the caller replaces the row instead. */
  function syncSwatchRow(picker, freshPicker) {
    var swatches = picker.querySelectorAll('.thumbnail-swatch'), freshSwatches = freshPicker.querySelectorAll('.thumbnail-swatch');
    if (!swatches.length || swatches.length !== freshSwatches.length) return false;
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].getAttribute('product_handle') !== freshSwatches[i].getAttribute('product_handle')) return false;
    }
    copyAttributes(picker, freshPicker);
    for (var j = 0; j < swatches.length; j++) {
      copyAttributes(swatches[j], freshSwatches[j]);
      if (swatches[j].parentElement && freshSwatches[j].parentElement) copyAttributes(swatches[j].parentElement, freshSwatches[j].parentElement);
    }
    var name = picker.querySelector('.product-card__color-name'), freshName = freshPicker.querySelector('.product-card__color-name');
    if (name && freshName) name.innerHTML = freshName.innerHTML;
    return true;
  }
  /* Swapped in place, the new colour's image replaced the old in one frame. The outgoing figure is instead laid over
     the new one, where it stood, and faded out once the new image has loaded, so the two crossfade. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function crossfadeCardFigure(card, oldFigure, box) {
    card.querySelectorAll(':scope > .product-card__swap-out').forEach(function(el) { el.remove(); });
    var figure = card.querySelector('.product-card__figure');
    if (!oldFigure || !figure || figure.parentNode !== card || reduceMotion.matches) return;
    figure.classList.add('is-swapped-in');
    oldFigure.removeAttribute('data-ab-slides'); // so product-card-ab.js doesn't build a carousel in the leaving copy
    var out = document.createElement('div');
    out.className = 'product-card__swap-out';
    out.style.cssText = 'top:' + box.top + 'px;left:' + box.left + 'px;width:' + box.width + 'px;height:' + box.height + 'px';
    out.appendChild(oldFigure);
    // Straight after the figure, so the info box, which slides up over the image on hover, still paints above it.
    card.insertBefore(out, figure.nextSibling);
    var faded = false;
    var fade = function() {
      if (faded) return;
      faded = true;
      requestAnimationFrame(function() { out.style.opacity = '0'; });
      out.addEventListener('transitionend', function() { out.remove(); });
      setTimeout(function() { out.remove(); }, 900);
    };
    var img = figure.querySelector('img');
    if (!img || img.complete) return fade();
    img.addEventListener('load', fade);
    img.addEventListener('error', fade);
    setTimeout(fade, 1500); // don't hold the old colour over a slow image
  }
  function swapCardHandles(card) {
    return $(card).find('.thumbnail-swatch[product_handle]').map(function() { return $(this).attr('product_handle'); }).get();
  }
  function preloadSwapImages(card) {
    swapCardHandles(card).forEach(function(handle) {
      fetchSwapCard(handle).done(function(data) {
        if (cardSwapImages[handle]) return;
        var img = new DOMParser().parseFromString(data, 'text/html').querySelector('.product-card__figure img');
        if (!img) return;
        // Same srcset and sizes as the card's own image, so the browser picks (and caches) the file the card will show.
        cardSwapImages[handle] = new Image();
        cardSwapImages[handle].sizes = img.getAttribute('sizes') || '';
        cardSwapImages[handle].srcset = img.getAttribute('srcset') || '';
        cardSwapImages[handle].src = img.getAttribute('src');
      });
    });
  }
  if ('IntersectionObserver' in window) {
    var idle = window.requestIdleCallback || function(fn) { return setTimeout(fn, 200); };
    var swapCardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        swapCardObserver.unobserve(entry.target);
        idle(function() { swapCardHandles(entry.target).forEach(fetchSwapCard); });
      });
    }, { rootMargin: '200px 0px' });
    var observeSwapCards = function() {
      document.querySelectorAll('.product-card:not(.byob-product-card)').forEach(function(card) {
        if (card.swapObserved || !card.querySelector('.thumbnail-swatch')) return;
        card.swapObserved = true;
        swapCardObserver.observe(card);
      });
    };
    observeSwapCards();
    // Cards also arrive later (filters, sorting, load more), so pick those up too.
    var swapScanQueued = false;
    new MutationObserver(function() {
      if (swapScanQueued) return;
      swapScanQueued = true;
      requestAnimationFrame(function() { swapScanQueued = false; observeSwapCards(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  $('body').on('mouseenter', '.product-card:not(.byob-product-card)', function() { preloadSwapImages(this); });
  /* The swatch row's scrollbar is hidden and most mice only scroll vertically, so over a row that overflows, the wheel
     moves it sideways; at either end it falls through to the page as usual. Bound per row on first hover rather than
     on the document, since a non-passive document wheel listener would make every page scroll wait on script.
     Desktop only: under 700px the row keeps its scrollbar and the wheel scrolls the page, as main does. */
  function scrollSwatchRowWithWheel(e) {
    var row = e.currentTarget, max = row.scrollWidth - row.clientWidth;
    if (!swatchRowDesktop.matches || max <= 0 || e.ctrlKey || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
    var delta = e.deltaY * (e.deltaMode === 1 ? 16 : 1);
    if ((delta < 0 && row.scrollLeft <= 0) || (delta > 0 && row.scrollLeft >= max - 1)) return;
    e.preventDefault();
    row.scrollLeft += delta;
  }
  /* Swatch-row arrows (Figma CRO 506:1242): the right one shows while there is more row to the right, the left one
     once the row has moved; each click moves the row one swatch that way. Rows are picked up as they appear, and
     re-checked on scroll and resize. No arrow when all that's left that way is the last swatch with at least half of
     it showing: it already reads as "more this way", and the arrow's box would only hide it. */
  function updateSwatchNext(row) {
    if (!row.parentElement) return;
    var rest = swatchRowGeometry(row, false), hover = swatchRowGeometry(row, true);
    row.parentElement.querySelectorAll(':scope > .product-card__swatch-next').forEach(function(button) {
      var isPrev = button.classList.contains('product-card__swatch-next--prev');
      // `hidden` only covers the moment before this runs: the theme makes it display:none !important, which can't
      // slide, so from here `is-off` classes slide the box away to its side instead (theme.css).
      button.hidden = false;
      [[rest, 'is-off-rest', '--swatch-next-cover-rest'], [hover, 'is-off', '--swatch-next-cover-hover']].forEach(function(state) {
        var geo = state[0], off = (isPrev ? geo.scrollLeft : geo.max - geo.scrollLeft) <= geo.half;
        button.classList.toggle(state[1], off);
        button.style.setProperty(state[2], (off ? 0 : swatchCover(row, isPrev, geo)) + 'px');
      });
    });
  }
  /* The row is narrower on hover (theme.css), so whether each arrow is needed, and how wide its box is, are worked
     out for the row at rest and on hover alike, wherever it is now: decided up front, nothing changes under an
     arrow as it slides in with the hover (measuring the moving row, the box resized after it had arrived and
     visibly sprang back). The picker sits 9px left of the info box's content edge at rest and is its content width
     + 18px; on hover it's at the content edge and the content width + 7px. The row reaches 2px past it each side.
     Each box's inner edge: the right box is 38px in from the row's end; the left one is too at rest, and on hover
     runs from the border, 9px left of the picker, 36px in (theme.css). */
  function swatchRowGeometry(row, hovered) {
    var picker = row.parentElement, info = picker.parentElement;
    var style = getComputedStyle(info), box = info.getBoundingClientRect();
    var left = box.left + parseFloat(style.borderLeftWidth) + parseFloat(style.paddingLeft) - (hovered ? 0 : 9);
    var width = box.width - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) + (hovered ? 7 : 18);
    var max = Math.max(0, row.scrollWidth - (width + 4));
    var scrollLeft = row.swatchAtEnd ? max : Math.min(row.scrollLeft, max);
    var swatch = row.querySelector('.thumbnail-swatch');
    return {
      rowLeft: left - 2,
      prevEdge: hovered ? left - 9 + 36 : left - 2 + 38,
      nextEdge: left + width + 2 - 38,
      max: max,
      scrollLeft: scrollLeft,
      // where a swatch measured now will be in this state: moved with the picker, less any scroll the width takes
      shift: left - picker.getBoundingClientRect().left - (scrollLeft - row.scrollLeft),
      half: Math.max(1, swatch ? swatch.getBoundingClientRect().width / 2 : 0)
    };
  }
  /* The box covers the end of the row wherever that falls, so it can leave part of a swatch showing at its inner
     edge: a strip of thumbnail beside the arrow, down to just that swatch's border (a click moves the row a swatch
     and a gap, which doesn't line up with the box). Under half the swatch showing, the box widens to cover it to the
     gap, the same half the arrow itself goes by; the extra goes on its padding (at most 8px of it between the box's
     inner edge and the arrow, the rest beyond the arrow: theme.css). */
  function swatchCover(row, isPrev, geo) {
    var extra = 0;
    var edge = isPrev ? geo.prevEdge : geo.nextEdge;
    Array.prototype.forEach.call(row.querySelectorAll('.thumbnail-swatch'), function(s) {
      var r = s.getBoundingClientRect(), l = r.left + geo.shift, rt = r.right + geo.shift;
      if (l >= edge || rt <= edge) return;
      var showing = isPrev ? rt - edge : edge - l;
      if (showing < r.width / 2) extra = Math.ceil(showing) + 2; // + the selected frame's 1px overhang, and a pixel of the gap
    });
    return extra;
  }
  /* At rest the row runs edge to edge, and a row just a few pixels too long for it (e.g. 6 colours on a ~306px card:
     314px of swatches at the Figma 10px gap) used to show its arrow over a sixth swatch that nearly fit. Such a row
     instead closes its gaps just enough for the last swatch to end flush at the right edge, as the first does at the
     left, down to the 6px mobile gap; anything longer keeps 10px and scrolls. Sized from the rest width (the info
     box's content + 18px, theme.css) so it doesn't change on hover and the swatches don't move. */
  var swatchRowDesktop = window.matchMedia('(min-width: 700px)');
  function fitSwatchRow(row) {
    var list = row.querySelector('.variant-picker__option-values');
    var info = row.parentElement.parentElement;
    if (!list || !info) return;
    list.style.gap = list.style.paddingInlineEnd = '';
    var wraps = Array.prototype.filter.call(list.querySelectorAll('.thumbnail-swatch_item-wrap'), function(w) { return w.getClientRects().length; });
    if (!swatchRowDesktop.matches || wraps.length < 2) return;
    var style = getComputedStyle(info);
    var restWidth = info.getBoundingClientRect().width - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
    var swatchesWidth = 0;
    wraps.forEach(function(w) { swatchesWidth += w.getBoundingClientRect().width; });
    var gap = (restWidth - swatchesWidth) / (wraps.length - 1);
    if (gap >= parseFloat(getComputedStyle(list).columnGap) || gap < 6) return;
    list.style.gap = gap + 'px';
    list.style.paddingInlineEnd = '0px'; // the scroll-end room isn't needed by a row that fits
  }
  // A row narrows on card hover (theme.css). Scroll position is kept from the left, so a row scrolled to its end would
  // lose its last swatch behind the new edge; one that was at its end is kept there as the width eases. Desktop only:
  // under 700px the row doesn't narrow and keeps its scroll from the left, as main does.
  var swatchRowResizeObserver = 'ResizeObserver' in window ? new ResizeObserver(function(entries) {
    entries.forEach(function(entry) {
      var row = entry.target;
      if (row.swatchAtEnd && swatchRowDesktop.matches) row.scrollLeft = row.scrollWidth;
      updateSwatchNext(row);
    });
  }) : null;
  function initSwatchNextButtons() {
    document.querySelectorAll('.product-card__swatch-next').forEach(function(button) {
      var row = button.parentElement.querySelector(':scope > .variant-picker__option');
      if (!row) return;
      if (!row.swatchNextBound) {
        row.swatchNextBound = true;
        // Recorded on scroll only: a refresh mid-resize would read a row that was at its end as no longer there.
        var recordEnd = function() { row.swatchAtEnd = row.scrollWidth - row.clientWidth > 1 && row.scrollLeft >= row.scrollWidth - row.clientWidth - 1; };
        recordEnd();
        row.addEventListener('scroll', function() { recordEnd(); updateSwatchNext(row); }, { passive: true });
        if (swatchRowResizeObserver) swatchRowResizeObserver.observe(row);
      }
      fitSwatchRow(row);
      updateSwatchNext(row);
    });
  }
  /* Eased scroll for the arrows. The browser's own smooth scroll covered most of a swatch in two or three frames and
     was done in ~150ms, which read as a jerk; this eases in and out over 300ms, the card's hover timing. A click
     during a slide carries on from where that slide is heading, so quick clicks don't stutter. */
  function slideSwatchRow(row, delta) {
    var max = row.scrollWidth - row.clientWidth;
    var from = row.scrollLeft;
    var to = Math.max(0, Math.min(max, (row.swatchSlideTo != null ? row.swatchSlideTo : from) + delta));
    row.swatchSlideTo = to;
    cancelAnimationFrame(row.swatchSlideFrame);
    var start = null;
    var frame = function(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / 300);
      var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      row.scrollLeft = from + (to - from) * eased;
      if (t < 1) row.swatchSlideFrame = requestAnimationFrame(frame);
      else row.swatchSlideTo = null;
    };
    row.swatchSlideFrame = requestAnimationFrame(frame);
  }
  $('body').on('click', '.product-card__swatch-next', function(e) {
    e.preventDefault();
    var row = this.parentElement.querySelector(':scope > .variant-picker__option');
    var swatches = row && row.querySelectorAll('.thumbnail-swatch');
    if (!swatches || !swatches.length) return;
    var step = swatches.length > 1 ? swatches[1].getBoundingClientRect().left - swatches[0].getBoundingClientRect().left : swatches[0].offsetWidth;
    var isPrev = this.classList.contains('product-card__swatch-next--prev');
    var from = row.swatchSlideTo != null ? row.swatchSlideTo : row.scrollLeft;
    slideSwatchRow(row, swatchStop(row, swatches, from, isPrev ? from - step : from + step, isPrev) - from);
  });
  /* Where a click stops the row: rather than a plain swatch further on (which left part of a swatch beside the left
     arrow, for its box to widen over, opening a wide blank gap there), at the stop nearest that with a swatch
     starting one gap clear of the left arrow's box, as the last swatch before the right arrow ends one gap short of
     it; or at either end. A stop within half a swatch of an end goes to the end. */
  function swatchStop(row, swatches, from, target, isPrev) {
    var geo = swatchRowGeometry(row, row.closest('.product-card').matches(':hover'));
    var rowBox = row.getBoundingClientRect(), max = row.scrollWidth - row.clientWidth;
    var gap = parseFloat(getComputedStyle(row.querySelector('.variant-picker__option-values')).columnGap) || 0;
    var stops = [0, max];
    Array.prototype.forEach.call(swatches, function(swatch) {
      var stop = swatch.getBoundingClientRect().left - rowBox.left + row.scrollLeft - (geo.prevEdge - geo.rowLeft) - gap;
      if (stop > geo.half && stop < max - geo.half) stops.push(stop);
    });
    var best = isPrev ? 0 : max;
    stops.forEach(function(stop) {
      if ((isPrev ? stop < from - 1 : stop > from + 1) && Math.abs(stop - target) < Math.abs(best - target)) best = stop;
    });
    return best;
  }
  initSwatchNextButtons();
  window.addEventListener('resize', initSwatchNextButtons);
  var swatchNextScanQueued = false;
  new MutationObserver(function() {
    if (swatchNextScanQueued) return;
    swatchNextScanQueued = true;
    requestAnimationFrame(function() { swatchNextScanQueued = false; initSwatchNextButtons(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('pointerover', function(e) {
    var row = e.target.closest && e.target.closest('.product-card .variant-picker__option');
    if (!row || row.swatchWheelBound) return;
    row.swatchWheelBound = true;
    row.addEventListener('wheel', scrollSwatchRowWithWheel, { passive: false });
  });
  document.addEventListener('touchstart', function(e) {
    var card = e.target.closest && e.target.closest('.product-card:not(.byob-product-card) .variant-picker');
    if (card) preloadSwapImages(card.closest('.product-card'));
  }, { passive: true });

  $('body').on('click', '.product-card:not(.byob-product-card) .thumbnail-swatch', function(e) {
    var _this = this;
    e.preventDefault();
    var product_handle = $(this).attr("product_handle");
    console.log('product_handle',product_handle);
    // $.get(`${product_handle}?view=product-card`, function (data) {
    //   $(_this).parents(".product-card_main").html($(data).html());
    //   console.log('data',$(data).html());
    // });
    $(_this).parents(".product-card_main").addClass('loading');
    // .done on an already-fetched request runs straight away, so a prefetched colour swaps in the same tick.
    fetchSwapCard(product_handle)
      .done(function(data) {
        console.log('data',`${product_handle}?view=product-card`,$(_this).parents(".product-card_main").html(),data);
        var $main = $(_this).parents(".product-card_main");
        $main.removeClass('loading');
        // Keep the hovered <product-card> mounted and swap only its contents. Replacing the card itself left the new
        // one un-hovered until the browser re-checked the pointer, so the whole hover state (info box sliding up,
        // borders fading in) replayed on every colour switch even though the cursor never left the card.
        var card = $main.children('product-card')[0];
        var freshCard = $('<div>').html(data).find('product-card')[0];
        if (card && freshCard) {
          var oldFigure = card.querySelector('.product-card__figure');
          var figureBox = oldFigure && { top: oldFigure.offsetTop, left: oldFigure.offsetLeft, width: oldFigure.offsetWidth, height: oldFigure.offsetHeight };
          // The swatch row is the same for every colour bar which one is selected, so it is kept mounted too and only
          // its classes move across: a fresh row would show the new selection instantly, while the kept one lets the
          // selected padding, border and size transition (and keeps a long row's scroll position).
          var info = card.querySelector(':scope > .product-card__info');
          var freshInfo = freshCard.querySelector(':scope > .product-card__info');
          var picker = info && info.querySelector(':scope > .variant-picker');
          var freshPicker = freshInfo && freshInfo.querySelector(':scope > .variant-picker');
          if (picker && freshPicker && syncSwatchRow(picker, freshPicker)) {
            swapChildrenKeeping(info, freshInfo, picker, freshPicker);
            swapChildrenKeeping(card, freshCard, info, freshInfo);
          } else {
            swapChildrenKeeping(card, freshCard, null, null);
          }
          crossfadeCardFigure(card, oldFigure, figureBox);
        } else {
          $main.html($(data).html());
        }
        _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);

    
        $('.product-card__media-list_main').each(function () {
          var $wrapper = $(this);
          var $slider = $wrapper.find('.product-card__media-list:not(.slick-initialized)');
          var $progressFill = $wrapper.find('.slick-progress-fill');
        
          $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
            var index = typeof currentSlide === 'undefined' ? 0 : currentSlide;
            var totalSlides = slick.slideCount;
            var percent = ((index + 1) / totalSlides) * 100;
        
            $progressFill.css('width', percent + '%');
          });
        
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            centerMode: false,
            responsive: [
              {
                breakpoint: 699,
                settings: {
                  arrows: false,
                  dots: false,
                }
              }
            ]
          });
        });
        setTimeout(function() {
        }, 1000);

        // $(_this).parents('.product-card_main').find(".thumbnail-swatch").removeClass('is-selected');
        // $(_this).addClass('is-selected');
        
        // $(_this).parents('.product-card_main').find(".product-card__figure").html($(data).find('.product-card__figure').html());
        // $(_this).parents('.product-card_main').find(".product-card__info").html($(data).find('.product-card__info').html());
      })
      .fail(function(xhr, status, error) {
        $(_this).parents(".product-card_main").removeClass('loading');
        console.error('AJAX error:', status, error);
      });
  });


  $('.offer-drawer__content-tab_link').click(function(e){
    e.preventDefault();
    $('.offer-drawer__content-tab_link').removeClass('active');
    $(this).addClass('active');
    $('.offer-drawer__content-tab-content-block').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $("body").on("click", ".offer-drawer-discount_finder_copy-code", function () {
    var copy_text = $(this);
    var text = $(this).attr('data-code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.text("copied","copied")
      
    setTimeout(function () {
      copy_text.text("Copy");
    }, 1000);
  });

  $('.global-offers-opner_button').click(function(e){
   e.preventDefault();
    $('html').addClass('lock');
   $('.offer-drawer').addClass('active');
   $('.offer-drawer_overlay').show();
  });
  $('.product-meta-global-offers--item_wrapper').click(function(e){
    e.preventDefault();

    // Get the target tab href (e.g., "#offer-drawer__content-tab-2")
    const targetHref = $(this).attr('data-id');

    // Open the offer drawer
    $('html').addClass('lock');
    $('.offer-drawer').addClass('active');
    $('.offer-drawer_overlay').show();

    // Trigger the click on the tab link (this runs your second function automatically)
    $(`.offer-drawer__content-tab_link[href="${targetHref}"]`).trigger('click');
  });


  $('.offer-drawer__close-button').click(function(e){
   e.preventDefault();
    $('html').removeClass('lock');
   $('.offer-drawer').removeClass('active');
   $('.offer-drawer_overlay').hide();
  });
  $('body').on('click', '.product-meta-global-offers_title', function() {
   $('.product-meta-global-offers_title').toggleClass('active');
   $('.product-meta_offers-content-block').slideToggle();
  });

  // HEADER MEGA MENU...
  $('.mega-menu').each(function () {
    const $menu = $(this);
    const $linkItems = $menu.find('.mega-menu__linklist-item');
    const $promoItems = $menu.find('.mega-menu__promo-item');
  
    $linkItems.hover(function () {
      const index = $(this).index();
  
      // Toggle active class
      $linkItems.removeClass('active');
      $(this).addClass('active');
  
      // Show corresponding promo item
      $promoItems.hide();
      $promoItems.eq(index).show();
    });
  
    // Optional: Reset active class & promo on mouseleave
    $menu.on('mouseleave', function () {
      $linkItems.removeClass('active');
      $promoItems.hide().first().show();
    });
  });

  $('button.header-sidebar__linklist-button').click(function(){
   $(this).toggleClass('active');
   $(this).next('header-sidebar-collapsible-panel').toggle();
  });

  $('.product-type-popup-button-text-close').click(function(){
   $(this).parent('.product-type-popup-button-text').hide();
  }); 

 $('body').on('click', '.sdi-btn-1', function (e) {
    e.preventDefault();
    const sbi_button = $(this);
    const sbi_button_text = $(this).find('.sdi-btn-text');
    const targett = $('#store-location-map');
    targett.toggleClass('active');
    if (targett.hasClass('active')) {
      sbi_button_text.text('Hide Map');
      $('html, body').animate({
        scrollTop: targett.offset().top
      }, 500);
    } else {
      sbi_button_text.text('View in Map');
    }
  });

});
$(window).on('scroll resize', function () {
  if ($(window).scrollTop() > 1000) {
    $('.go-top').addClass('show');
  } else {
    $('.go-top').removeClass('show');
  }
});

$('.gyb-featured-collection-product-list').each(function () {

  var $carousel = $(this);

  var flkty = $carousel.flickity({
    freeScroll: true,
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    groupCells: 2,
    imagesLoaded: true
  }).data('flickity');

  $(window).on('load', function () {
    flkty.resize();
  });

});

// PDP VIDEO-------------------------
$(document).on('click', '.product-gallery__video--controls_button.play-pause', function () {

  var $btn = $(this);
  var $wrapper = $btn.closest('video-media');
  var video = $wrapper.find('video').get(0);

  if (!$wrapper.attr('loaded')) {
    $wrapper.attr('loaded', 'loaded');
  }

  if (video.paused) {
    video.play().catch(function(){});
    
    $btn.addClass('active');
    $wrapper.attr('playing', 'playing'); // add playing attribute

  } else {
    video.pause();
    
    $btn.removeClass('active');
    $wrapper.removeAttr('playing'); // remove playing attribute
  }

});


$(document).on('click', '.product-gallery__video--controls_button.sound', function () {

  var $btn = $(this);
  var video = $btn.closest('video-media').find('video').get(0);

  if (video.muted) {
    video.muted = false;
    $btn.addClass('active');
  } else {
    video.muted = true;
    $btn.removeClass('active');
  }

});

$(document).ready(function () {
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    function scrollcode(){
      var loadingImage;
      var pInfScrNode = $('.product-list').find('.next-page_link');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        var pInfScrURL = $('.product-list').find('.next-page_link a').attr("href");
        $('.collection__main').append('<img src="https://cdn.shopify.com/s/files/1/0092/3831/5068/files/transparent-loader.gif?v=1751462450" class="new-page-loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            // loadingImage = pInfScrNode.clone().empty().append('');
            // loadingImage.insertAfter(pInfScrNode);
            // pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {    
            $('.product-card__media-list.slick-initialized').slick('unslick');
            // remove loading feedback
            pInfScrNode.next().remove();
            $('.product-list').find('.next-page_link').remove();
            var filteredData = $(data).find(".product-list");
            $('.product-list').append(filteredData.html());

            $('.product-card__media-list_main').each(function () {
              var $wrapper = $(this);
              var $slider = $wrapper.find('.product-card__media-list:not(.slick-initialized)');
              var $progressFill = $wrapper.find('.slick-progress-fill');
            
              $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
                var index = typeof currentSlide === 'undefined' ? 0 : currentSlide;
                var totalSlides = slick.slideCount;
                var percent = ((index + 1) / totalSlides) * 100;
            
                $progressFill.css('width', percent + '%');
              });
            
              $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                centerMode: false,
                responsive: [
                  {
                    breakpoint: 699,
                    settings: {
                      arrows: false,
                      dots: false,
                    }
                  }
                ]
              });
            });
            
            // loadingImage.remove();	              
            $('.collection__main').find('.new-page-loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

          },
          dataType: "html"
        });
      }
    }
    if($('.collection__main[collection_sorting="true"]').length > 0){
      scrollcode();
    }else{
      if( $('product-list').height() - 400 < $(document).scrollTop()) {
        scrollcode();
      }
    }
  }
  if($('.collection__main[collection_sorting="true"]').length > 0){
    function runInfScroll() {
      pInfScrExecute();
      if ($('.product-list .next-page_link').length > 0) {
        setTimeout(runInfScroll, pInfScrDelay);
      } else {
        console.log('No more products to load.');
      }
    }
    runInfScroll();
  }else{
    $(document).ready(function () {
      $(window).scroll(function(){
        $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
        // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
        if( $('.product-list').height() - 400 < $(document).scrollTop()) {
          pInfScrDelay = 20;
        }
      });
    });

    // $(window).scroll(function(){
    //   $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    //   if( $('.product-list').height() - 400 < $(document).scrollTop()) {
    //     pInfScrDelay = 20;
    //   }
    // });
  }
});
$(document).on('click', '#downloadCatalogue', function (e) {
  e.preventDefault();
  const url = this.href;

  fetch(url)
    .then(res => res.blob())
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'miraggiolife.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    });
});



const path = window.location.pathname;
document.querySelectorAll(".faq-navigation ul li a").forEach(function (link) {
  if (link.getAttribute("href") === path) {
    link.classList.add("active");
  }
});
document.querySelectorAll(".accordian .content").forEach(function (content) {
  content.classList.add("hidden");
});
document.querySelectorAll(".accordian h3").forEach(function (header) {
  header.addEventListener("click", function () {
    if (header.classList.contains("active")) {
      header.classList.remove("active");
      header.nextElementSibling.classList.add("hidden");
    } else {
      document.querySelectorAll(".accordian h3").forEach(function (accordian) {
        accordian.classList.remove("active");
        accordian.nextElementSibling.classList.add("hidden");
      });
      header.classList.add("active");
      header.nextElementSibling.classList.remove("hidden");
    }
  });
});

if($('[createCustomerForm]').length > 0){
  $('body').on('submit','[createCustomerForm]', function (e) {
  e.preventDefault();

  var _this = $(this);
  $('.backpack-modal').removeClass('success');
  $('.backpack-modal_form--success').hide();
  _this.find('.backpack-modal_form--error').remove();

  // get values
  var name = _this.find('[name="name"]').val().trim();
  var email = _this.find('[name="email"]').val().trim();
  var phoneRaw = _this.find('[name="phone"]').val();
  // var message = _this.find('[name="message"]').val().trim();

  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    _this.find('[type="submit"]').attr('aria-busy', 'false');
    _this.append('<p class="backpack-modal_form--error">Please enter a valid email address.</p>');
    return;
  }

  // clean phone (remove spaces, +, -, etc.)
  phoneRaw = phoneRaw.replace(/\D/g, '');
  var phoneRegex = /^[6-9]\d{9}$/;
  if (!phoneRegex.test(phoneRaw)) {
    _this.find('[type="submit"]').attr('aria-busy', 'false');
    _this.append('<p class="backpack-modal_form--error">Please enter a valid 10 digit number.</p>');
    return;
  }

  // set loading state AFTER validation
  _this.find('[type="submit"]').attr('aria-busy', 'true');

  var phone = '91' + phoneRaw;

  $.ajax({
    url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
    method: "POST",
    contentType: "application/json",
    headers: {
      "Authorization": "970614a6802448fd87feb315a2fc121d"
    },
    data: JSON.stringify({
      first_name: name,
      email: email,
      phone: phone,
      // message: message,
      tag: 'got your back',
    }),
    success: function (response) {
      // console.log(response);
      // if(response.message == 'Your details already exist in our list'){
      //   $('.backpack-modal_wrapper').append(`<p class="backpack-modal_form--success"> You've successfully subscribed </p>`);
      // }else if(response.message == `You've successfully subscribed to our waitlist.`){
      //   $('.backpack-modal_wrapper').append(`<p class="backpack-modal_form--success"> You've successfully subscribed </p>`);
      // } else {
      //   $('.backpack-modal_wrapper').append(`<p class="backpack-modal_form--success">${response.message}</p>`);
      // }
      _this.find('[type="submit"]').attr('aria-busy', 'false');
      $('.backpack-modal').addClass('success');
      $('.backpack-modal_inner').hide();
      $('.backpack-modal_form--success').show();

      setTimeout(function () {
        $('html').removeClass('lock');
        $('.backpack-modal-overlay').removeClass('is-active');
        $('.backpack-modal').removeClass('is-active');
        $('.backpack-modal_form-input--field').val('');

        $('.backpack-modal').removeClass('success');
        $('.backpack-modal_inner').show();
        $('.backpack-modal_form--success').hide();
      }, 5000);
    },

    error: function (xhr) {
      console.log(xhr);
      let msg = "Something went wrong!";
      if (xhr.responseJSON && xhr.responseJSON.message) {
        msg = xhr.responseJSON.message;
      }
      _this.append('<p class="backpack-modal_form--error">' + msg + '</p>');
    }
  });
});
}


// -------------------------------------------
// BYOB START

$(document).ready(function () {
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if($('#step-1').height() - 400 < $(document).scrollTop() && $('#step-1').hasClass('is-active')) {
      var loadingImage;
      var pInfScrNode = $('#step-1').find('.byob-next-page_link');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        var pInfScrURL = $('#step-1').find('.byob-next-page_link a').attr("href");
        $('#step-1').append('<img src="https://cdn.shopify.com/s/files/1/0092/3831/5068/files/transparent-loader.gif?v=1751462450" class="byob-new-page-loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;          
            console.log('loading...');
          },
          success: function(data) {    
            // remove loading feedback
            pInfScrNode.next().remove();
            $('#step-1').find('.byob-next-page_link').remove();
            var filteredData = $(data).find("#step-1 .byob-step_product-grid");
            $('#step-1 .byob-step_product-grid').append(filteredData.html());
            
            // loadingImage.remove();	              
            $('#step-1').find('.byob-new-page-loading').remove();
            pInfScrLoading = false;
          },
          dataType: "html"
        });
      }
    }
  }
  
  $(window).scroll(function(){
    $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    if( $('#step-1').height() - 400 < $(document).scrollTop()) {
      pInfScrDelay = 20;
    }
  });
});



if($('.byob_main_page').length > 0){

  function updatedata(){
    var bundle_price = 0;
    var bundle_compare_price = 0; 
    $('.bundle-preview_cart-item').each(function(i,v){
      if(!$(this).hasClass('hasblank')){
        bundle_price = bundle_price + parseInt($(this).find('.bundle-preview_cart-item-wrapper').attr('data-price'));
        bundle_compare_price = bundle_compare_price + parseInt($(this).find('.bundle-preview_cart-item-wrapper').attr('data-compare-price'));
      }
    });

    $('.bundle-preview_cart-prices .price:not(.price--compare)').html(formatMoney(bundle_price, currencyFormat));
    $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));

    if(bundle_price == 0){
      $('.bundle-preview_cart-prices').hide();
    }else{
      $('.bundle-preview_cart-prices').show();
    }
  }

  function updateProgressItems(currentStepIndex) {
    var $items = $('.byob-step_progress-bar--item');
    $items.hide(); // hide all by default
    currentStepIndex = parseInt(currentStepIndex)
    // Show current + next 2 steps
    if(currentStepIndex + 2 > $items.length){
      for (var i = $items.length; i >= 3; i--) {
        $items.eq(i - 1).show();
      }  
    }else{
      for (var i = currentStepIndex - 1; i < currentStepIndex + 2; i++) {
        $items.eq(i).show();
      }
    }
    
  }

  function updateProgressBar(currentStepIndex) {
    var totalSteps = $('.byob-step_item').length;
    var percent = ((currentStepIndex - 1) / (totalSteps - 1)) * 100;
    $('.byob-step_progress-bar--fill').css('width', percent + '%');
  }

  function updateNavButtons(stepIndex) {
    stepIndex = parseInt(stepIndex);
    var totalSteps = $('.byob-step_item').length;
    // Show Prev and Next buttons initially
    $('.bundle-step-prev-next.prev').show();
    $('.bundle-step-prev-next.next').show();

    // Disable Prev on first step
    if (stepIndex === 1) $('.bundle-step-prev-next.prev').attr('disabled', true);
    else $('.bundle-step-prev-next.prev').removeAttr('disabled');
    $('.emptyerr').remove();
    $('.byob-preview-review_bundle').removeAttr('disabled');
    // On last step: hide Next, show cart buttons
    if (stepIndex === totalSteps) {
      console.log($('.bundle-preview_cart-item.hasblank').not('[data-step="step-5"]').length)
      if($('.bundle-preview_cart-item.hasblank').not('[data-step="step-5"]').length > 0){
        $('.bundle-preview_cart-buttons').prepend('<p class="emptyerr">Please select all mandtory items to proceed further.</p>')
        $('.byob-preview-review_bundle').attr('disabled','disabled');
      }
      $('.bundle-step-prev-next.next').hide();
      $('[data-review-bundle]').show();
    } else {
      $('.bundle-step-prev-next.next').show();
      $('[data-review-bundle]').hide();
      controlNextBtn(stepIndex);
    }

    updateProgressBar(stepIndex);
    if($(window).width() < 640){
      updateProgressItems(stepIndex);
    }
  }

  function controlNextBtn(stepIndex) {
    var $currentStep = $('.byob-step_item.is-active');
    var $nextBtn = $('.bundle-step-prev-next.next');
    console.log('innn')
    // Step 3 Next always enabled    
    if(stepIndex == 5){
      if($currentStep.hasClass('is-product-selected')){
        $('.byob-preview-review_bundle').text('Review');
      }else{
        $('.byob-preview-review_bundle').text('Skip');
      }
      $nextBtn.removeAttr('disabled');
    } else {
      // Other steps: Next enabled only if a product is selected
      if ($currentStep.find('.byob-product_item-addbtn.added').length > 0) {
        $nextBtn.removeAttr('disabled');
      } else {
        $nextBtn.attr('disabled', true);
      }
      $nextBtn.text('Next');
    }
  }

  updateNavButtons(1);
  controlNextBtn(1);

  // Product "Add to box" click
  $('body').on('click', '.byob-product_item-addbtn', function(e) {
    e.preventDefault();

    var _this = this;
    var $currentStep = $(this).closest('.byob-step_item');
    var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
    var product_handle = $(this).closest('.byob-product_item').attr("product_handle");
    
    // Unselect other products in this step except step 1
    $currentStep.find('.byob-product_item-addbtn').removeClass('added');
    $(this).addClass('added');

    $currentStep.addClass('is-product-selected');
    $('.byob-step_progress-bar--item[step="'+currentStepIndex+'"]').addClass('is-page-selected');

    // AJAX load for main product (step 1), update steps 2,4,5
    if($(this).hasClass('byob-main-product_item-addbtn')){
      $(this).closest(".byob-main").addClass('loading');
      $(this).attr("aria-busy",true);
      $(this).attr('disabled','disabled').removeClass('added');
      // $('.bundle-preview_cart-item:not([data-step="step-1"])').html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank').removeAttr('data-vid data-pid data-price data-compare-price property-value');

      $(".byob-step_item").not('[step="1"]').removeClass('is-product-selected');
      $('.byob-step_progress-bar--item').not('[step="1"]').removeClass('is-page-selected');
      $(".byob-step_item").not('[step="1"]').find('.byob-product_item-addbtn').removeClass('added').find('.button--text').text('Add to box');

      if ($(this).is('.byob-main-product_item-addbtn:not(.added)')) {
        $(`.bundle-preview_cart-item[data-step="step-2"],.bundle-preview_cart-item[data-step="step-3"],.bundle-preview_cart-item[data-step="step-4"],.bundle-preview_cart-item[data-step="step-5"]`).html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank')      
      }
      // $('.addall_to_cart_button').attr('disabled','disabled');
      
      // bundle_price = parseInt($(this).closest('.byob-product_item').attr('data-product-price'));
      // bundle_compare_price = parseInt($(this).closest('.byob-product_item').attr('data-product-compare-price'));
      
      $.ajax({
        type: 'GET',
        url: `/products/${product_handle}?view=byob-product-list`,
        success: function(data) {
          $("#step-2").html($(data).find('#step-2').html());
          $("#step-4").html($(data).find('#step-4').html());
          $("#step-5").html($(data).find('#step-5').html());
          $(_this).closest(".byob-main").removeClass('loading');
          $(_this).removeAttr("aria-busy");
          $(_this).closest(".byob-main").find('.byob-main-product_item-addbtn').removeAttr('disabled');
          $(_this).closest(".byob-step_item").find('.byob-main-product_item-addbtn').removeClass('added').find('.button--text').text(`Add to box`);
          $(_this).addClass('added').find('.button--text').text(`Added`);

          // $('.bundle-preview_cart-prices .price:not(.price--compare)').html(formatMoney(bundle_price, currencyFormat));
          // $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
          // $('.bundle-preview_cart-prices').show();

          // Update cart preview for the current step
          var step = $currentStep.attr('id');  
          var featuredimage = $(_this).closest('.byob-product_item').attr('data-featuredimage');
          var itembox = `<div class="bundle-preview_cart-item-wrapper" 
            data-title="${$(_this).closest('.byob-product_item').attr('data-product-name')}"
            data-vid="${$(_this).closest('.byob-product_item').attr('data-variant-id')}"
            data-pid="${$(_this).closest('.byob-product_item').attr('data-product-id')}"
            data-price="${$(_this).closest('.byob-product_item').attr('data-product-price')}"
            data-compare-price="${$(_this).closest('.byob-product_item').attr('data-product-compare-price')}"
            property-value="${$(_this).closest('.byob-product_item').attr('data-product-name')}">
            <a href="javascript:void(0)" class="preview_step_call" data-step="${$(_this).closest('.byob-step_item').attr('step')}">
              <img src="${featuredimage}" loading="lazy" width="50" height="50" alt="">
            </a>
            </div>`; 
          $(`.bundle-preview_cart-item[data-step="${step}"]`).removeClass('hasblank').html(itembox);

          // if ($(_this).closest('#step-5').length) {
          //   $('[data-review-bundle]').removeAttr('disabled');
          // }
          updatedata();
          // Update navigation buttons state (Next/Prev)
          controlNextBtn(currentStepIndex);
          updateNavButtons(currentStepIndex)

        },
        error: function(xhr, status, error) {
          $(_this).closest(".byob-main").removeClass('loading');
          console.error('AJAX error:', status, error);
        }
      });
    } else {
      $(this).closest('.byob-step_item').find('.byob-product_item-addbtn').removeClass('added').find('.button--text').text('Add to box');
      $(this).addClass('added').find('.button--text').text('Added');
      $(this).closest(".byob-main").removeClass('loading');

      // $('.bundle-preview_cart-prices .price:not(.price--compare)').html(formatMoney(bundle_price, currencyFormat));
      // $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
      // $('.bundle-preview_cart-prices').show();

      // Update cart preview for the current step
      var step = $currentStep.attr('id');  
      var featuredimage = $(_this).closest('.byob-product_item').attr('data-featuredimage');
      var itembox = `<div class="bundle-preview_cart-item-wrapper" 
        data-title="${$(_this).closest('.byob-product_item').attr('data-product-name')}"
        data-vid="${$(_this).closest('.byob-product_item').attr('data-variant-id')}"
        data-pid="${$(_this).closest('.byob-product_item').attr('data-product-id')}"
        data-price="${$(_this).closest('.byob-product_item').attr('data-product-price')}"
        data-compare-price="${$(_this).closest('.byob-product_item').attr('data-product-compare-price')}"
        property-value="${$(_this).closest('.byob-product_item').attr('data-product-name')}">
        <a href="javascript:void(0)" class="preview_step_call" data-step="${$(this).closest('.byob-step_item').attr('step')}">
          <img src="${featuredimage}" loading="lazy" width="50" height="50" alt="">
        </a>
        </div>`; 
      $(`.bundle-preview_cart-item[data-step="${step}"]`).removeClass('hasblank').html(itembox);

      // if ($(_this).closest('#step-5').length) {
      //   $('[data-review-bundle]').removeAttr('disabled');
      // }
      updatedata();

      // Update navigation buttons state (Next/Prev)
      controlNextBtn(currentStepIndex);
      updateNavButtons(currentStepIndex)
    }

  });

  $('body').on('click', '.preview_step_call', function() {
    var $currentStep = $('.byob-step_item.is-active');
    var $nextStep = $('.byob-step_item[step="'+$(this).attr('data-step')+'"]');

    $('.byob-step_progress-bar--item').removeClass('active')
    for(var i = 0;i < parseInt($(this).attr('data-step'));i++){
      $('.byob-step_progress-bar--item').eq(i - 1).addClass('active')
    }

    if($(window).width() < 640){
      updateProgressItems($(this).attr('data-step'));
    }
    
    $currentStep.removeClass('is-active');
    $nextStep.addClass('is-active');
    $('.byob_slide').removeClass('active');
    $('.byob_slide[step="'+$(this).attr('data-step')+'"]').addClass('active');
    $('.byob-step_progress-bar--item').removeClass('is-page-active');
    $('.byob-step_progress-bar--item[step="'+$(this).attr('data-step')+'"]').addClass('is-page-active');
    updateNavButtons($(this).attr('data-step'));
  });

  // Next button click handling
  $('body').on('click', '.bundle-step-prev-next.next', function() {
    if ($(this).is('[disabled]')) return;
    var $currentStep = $('.byob-step_item.is-active').attr('step');
    var nextstep = parseInt($currentStep) + 1;
    // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
    var $nextStep = $('.byob-step_item[step="'+nextstep+'"]');

    $('.byob-step_progress-bar--item').removeClass('active')
    for(var i = 0;i < $currentStep;i++){
      $('.byob-step_progress-bar--item').eq(i).addClass('active')
    }
    if($(window).width() < 640){
      updateProgressItems(nextstep);
    }

    if ($nextStep.length) {
      $('.byob-step_item').removeClass('is-active');
      $nextStep.addClass('is-active');
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      $('.byob_slide').removeClass('active');
      $('.byob_slide[step="'+nextstep+'"]').addClass('active');
      $('.byob-step_progress-bar--item').removeClass('is-page-active');
      $('.byob-step_progress-bar--item[step="'+nextstep+'"]').addClass('is-page-active');
      updateNavButtons(nextstep);
    }
  });

  // Prev button click handling
  $('body').on('click', '.bundle-step-prev-next.prev', function() {
    var $currentStep = $('.byob-step_item.is-active').attr('step');
    var prevstep = parseInt($currentStep) - 1;
    // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
    var $prevStep = $('.byob-step_item[step="'+prevstep+'"]');

    $('.byob-step_progress-bar--item').removeClass('active')
    for(var i = 0;i < $currentStep - 1;i++){
      $('.byob-step_progress-bar--item').eq(i - 1).addClass('active')
    }
    if($(window).width() < 640){
      updateProgressItems(prevstep);
    }

    if ($prevStep.length) {
      $('.byob-step_item').removeClass('is-active');
      $prevStep.addClass('is-active');
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      $('.byob_slide').removeClass('active');
      $('.byob_slide[step="'+prevstep+'"]').addClass('active');
      $('.byob-step_progress-bar--item').removeClass('is-page-active');
      $('.byob-step_progress-bar--item[step="'+prevstep+'"]').addClass('is-page-active');
      updateNavButtons(prevstep);
    }
  });

  // Handle product removal
  $('body').on('click', '.byob-product_item-btn-remove', function(e){
    e.preventDefault();

    var $step = $(this).closest('.byob-step_item');
    var $productItem = $(this).closest('.byob-product_item');

    // Reset add button state & text
    

    // Clear step 3 cart preview
    if($(this).closest('.byob-step_item').attr('step') == "1"){
      $('.byob-step_item').find('.byob-product_item-addbtn').removeClass('added').find('.button--text').text('Add to box');
      $(`.bundle-preview_cart-item`).html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank');
    }else{
      $productItem.find('.byob-product_item-addbtn').removeClass('added').find('.button--text').text('Add to box');
      $(`.bundle-preview_cart-item[data-step="step-${$(this).closest('.byob-step_item').attr('step')}"]`).html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank');
    }
    // $(`.bundle-preview_cart-item[data-step="step-${$(this).closest('.byob-step_item').attr('step')}"]`).html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank');

    // Remove product-selected class
    $step.removeClass('is-product-selected');
    $('.byob-step_progress-bar--item[step="'+$step.attr('step')+'"]').removeClass('is-page-selected');

    // if($('.bundle-preview_cart-item.hasblank:not([data-step="step-3"])').length <= 4){
    //   $('[data-review-bundle]').attr('disabled','disabled')
    // }
    if($step.attr('step') == '1'){
      $(`.bundle-preview_cart-item[data-step="step-2"],.bundle-preview_cart-item[data-step="step-3"],.bundle-preview_cart-item[data-step="step-4"],.bundle-preview_cart-item[data-step="step-5"]`).html('<div class="bundle-preview_cart-item-wrapper">Add</div>').addClass('hasblank')
      $("#step-2").html(`<div class="byob-step_item-wrapper"><div class="byob-step_product-grid"><div class="byob-step_product-grid_blank-text">No product</div></div></div>`).removeClass('is-product-selected');
      $("#step-3").removeClass('is-product-selected');
      $("#step-4").html(`<div class="byob-step_item-wrapper"><div class="byob-step_product-grid"><div class="byob-step_product-grid_blank-text">No product</div></div></div>`).removeClass('is-product-selected');
      $("#step-5").html(`<div class="byob-step_item-wrapper"><div class="byob-step_product-grid"><div class="byob-step_product-grid_blank-text">No product</div></div></div>`).removeClass('is-product-selected');
    }

    updatedata();
    // Keep Next button enabled for step 3 since it's optional
    controlNextBtn($step.attr('step'));
    updateNavButtons($step.attr('step'))
  });

  $('body').on('click', '[data-review-bundle]', function() {

    var subiteminfo = '';
    var cartbundleprice = 0;
    $('.bundle-preview_cart-item').each(function(i,v){
      var item_price_before_money = parseInt($(this).find('.bundle-preview_cart-item-wrapper').attr('data-price'));
      var item_price = formatMoney(item_price_before_money, currencyFormat);
      if(item_price_before_money == 0){
        var item_price = 'Free';
      }

      var title_lable = '';
      switch (i) {
        case 0:
          var title_lable = 'Bag';
          break;

        case 1:
          var title_lable = 'Box';
          break;

        case 2:
          var title_lable = 'Charms';
          break;

        case 3:
          var title_lable = 'Dust Bag';
          break;

        case 4:
          var title_lable = 'Greeting Card';
          break;

        default:
          var title_lable = 'Bag';
      }

      if($(this).find('.bundle-preview_cart-item-wrapper').attr('data-title')){
        subiteminfo += `<div class="byob-preview-subitem_list">
          <div class="byob-preview-item_data">
            <div class="byob-preview-item-name">${title_lable}: ${$(this).find('.bundle-preview_cart-item-wrapper').attr('data-title')}</div>
          </div>
          <div class="byob-preview-item-price">${item_price}</div>
        </div>`;  
        cartbundleprice += parseInt($(this).find('.bundle-preview_cart-item-wrapper').attr('data-price'));
      }
    });
    $('.byob_total_cart .byob-preview-item-info').html(subiteminfo);
    $('.byob_total_cart [data-bundle-total]').html(formatMoney(cartbundleprice, currencyFormat));
    $('.byob-main').hide();
    $('.byob_total_cart').show();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  $('body').on('click', '.byob-preview-bundle-edit', function() {
    $('.byob-main').show();
    $('.byob_total_cart').hide();
  });

  var oldhtml = $('.byob-main').html();
  $('body').on('click', '.byob--create-new-box,.byob-preview-bundle-remove', function() {
    $('.byob-main').html(oldhtml).show();
    $('.byob_total_cart').hide();
  });

  $('body').on('click', '.bundle-add_to_cart_button', function() {
    var _this = this;
    $(_this).attr("aria-busy", true);
    var qty = $(_this).closest('.byob_total_cart').find('[name="quantity"]').val();
    var items = [];

    // Generate unique bundle ID
    var bundle_id = 'bundle_' + Date.now() + '_' + Math.floor(Math.random() * 100000);

    var bundle_number = 1;
    console.log($('.line-item.hasproperties').length);
    if($('.line-item.hasproperties').length == 0){
      bundle_number = 1;
    }else{
      bundle_number = parseInt($('.line-item.hasproperties').first().attr('data-itemnumber'), 10) + 1;
    }

    var main_key_properties = {
      _type: 'byob',
      _personalize: 'main',
      _bundleid: bundle_id,
      _mainqty: qty,
      _bundle_number: bundle_number
    };
    $(_this).closest('.section-stack').find('.bundle-preview_cart-main .bundle-preview_cart-item:not(.hasblank)').each(function(i, v) {
      var val = $(this).find('.bundle-preview_cart-item-wrapper').attr('data-vid');
      var step = $(this).attr('data-step'); // e.g. "step-1", "step-2", etc.
      
      var properties = {};

      // Add properties only if not step 1
      if (step !== 'step-1') {
        var type = 'sub';
        properties = {
          _personalize: type,
          _bundleid: bundle_id,
          _mainqty: qty,
          _bundle_number: bundle_number
        };

        var property_key = $(this).attr('property-key');
        var property_value = $(this).find('.bundle-preview_cart-item-wrapper').attr('property-value');
        if (property_key && property_value) {
          main_key_properties[property_key] = property_value;
        }
      }
      if(step == 'step-1'){
        items.push({
          quantity: qty,
          id: val,
          properties: properties
        });
      }else{
        items.push({
          quantity: qty,
          id: val,
          parent_id: items[0].id,
          properties: properties
        });
      }
      
    });

    console.log('main_key_properties',main_key_properties);
    items[0].properties = main_key_properties;

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      })
    );

    var data = { 
      items,
      sections: sectionsToBundle.join(",")
    };

    console.log('data', data);

    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) { 
      return response.json();
    })
    .then(function(responseJson) {
      return fetch(`${Shopify.routes.root}cart.js`)
        .then(response => response.json())
        .then(cartContent => {
          cartContent["sections"] = responseJson["sections"];

          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo: 'force_open_drawer',
              cart: cartContent
            }
          }));

          $(_this).removeAttr("aria-busy");
        });
    })
    .catch(function(error) {
      console.error('Error adding bundle to cart:', error);
      $(_this).removeAttr("aria-busy");
    });


  }); 

}

// -------------------------------------------
// BYOB OVER


// -------------------------------------------
// VIEW SIMILER LOGIC START
function loadSimilarProducts(maxPages = 10, maxResults = 8) {
  const $current = $('#featched-product-detail');
  const currentCategory = $current.attr('primary_category');
  const $popup = $('.similar-product-popup_main');
  const $selected_collection_url = $current.attr('collection-url');

  if (!currentCategory || $popup.length === 0) {
    console.warn("⚠️ Missing primary_category or popup container.");
    return;
  }

  let page = 1;
  let foundCount = 0;
  let isLoading = false;

  // Add loading class at the start
  $popup.addClass('loading');

  function fetchNextPage() {
    if (page > maxPages || foundCount >= maxResults) {
      // Done fetching — remove loading class
      $popup.removeClass('loading');
      console.log(`✅ Done — found ${foundCount} similar products.`);
      return;
    }

    const url = `${$selected_collection_url}?page=${page}`;
    console.log(`🔍 Fetching page ${page} for category "${currentCategory}"`);

    $.ajax({
      type: "GET",
      url,
      dataType: "html",
      success: function (data) {
        const $cards = $(data).find('.product-card_main');

        $cards.each(function () {
          if (foundCount >= maxResults) return false; // stop .each
          const $card = $(this);
          const prodCategory = $card.attr('primary_category');

          if (prodCategory === currentCategory) {
            const clone = $card.clone();
            $('.similar-products-items-list').append(clone);
            // $('.featured-type_product_list').append(clone);
            // $('.featured-color_product_list').append(clone);
            foundCount++;
          }
        });

        page++;
        fetchNextPage(); // recursive next page
      },
      error: function () {
        console.warn(`⚠️ Failed to load page ${page}`);
        // Remove loading on error
        $popup.removeClass('loading');
      }
    });
  }

  fetchNextPage();
}

// Run on page load
$(document).ready(function () {
  if($('#featched-product-detail').length > 0){
    loadSimilarProducts(10, 8);
  }
});

// VIEW SIMILER LOGIC END
// ============================================================================
// CONTENT PROTECTION
// Active only when <body> has the "content-protected" class, which the theme
// adds via Liquid when the "Enable content protection" theme setting is on
// (and never inside the theme editor). Deterrent only — the page source is
// always sent to the browser, so this cannot fully stop a determined user.
// ============================================================================
(function () {
  function init() {
    if (!document.body || !document.body.classList.contains('content-protected')) {
      return;
    }

    // Let customers still interact normally with form fields.
    function inEditable(el) {
      if (!el || !el.tagName) return false;
      var tag = el.tagName;
      return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
    }

    // Note: all listeners use the capture phase (third arg = true) so they run
    // before any app/widget script can stopPropagation() the event. This keeps
    // protection working inside in-DOM app popups, sticky bars and embeds.

    // Block right-click context menu (also fires on Android/Chrome long-press)
    document.addEventListener('contextmenu', function (e) {
      if (inEditable(e.target)) return;
      e.preventDefault();
    }, true);

    // Block text selection / copy / cut (selectstart covers Chrome/Safari/Edge;
    // copy/cut cover Firefox, which ignores selectstart)
    ['selectstart', 'copy', 'cut'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (inEditable(e.target)) return;
        e.preventDefault();
      }, true);
    });

    // Block dragging images out to save them.
    // dragstart preventDefault works in Chrome/Safari/Edge/Firefox; the
    // draggable attribute is the belt-and-braces fallback for older Firefox.
    document.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    }, true);

    function lockImages(root) {
      var imgs = (root || document).getElementsByTagName('img');
      for (var i = 0; i < imgs.length; i++) { imgs[i].setAttribute('draggable', 'false'); }
    }
    lockImages(document);
    // Re-lock images added later (quick-views, lazy galleries, infinite scroll)
    if ('MutationObserver' in window) {
      new MutationObserver(function () { lockImages(document); })
        .observe(document.body, { childList: true, subtree: true });
    }

    // Block dev-tools / view-source / save / print shortcuts across
    // Windows/Linux (Ctrl), macOS (Cmd / Cmd+Opt) and Firefox-specific combos.
    document.addEventListener('keydown', function (e) {
      var ctrlOrCmd = e.ctrlKey || e.metaKey;

      // IMPORTANT: use e.code (the physical key) rather than e.key. On macOS,
      // holding Option turns e.key into a special character (Option+I -> "ˆ"),
      // so e.key === 'i' never matches. e.code stays "KeyI" no matter which
      // modifiers are held. Fall back to e.key for very old browsers.
      var code = e.code || '';
      var letter = code.indexOf('Key') === 0
        ? code.charAt(3).toLowerCase()
        : (e.key || '').toLowerCase();

      function isOneOf(list) { return list.indexOf(letter) !== -1; }

      // F12 -> dev tools (Chrome / Firefox / Edge)
      if (e.key === 'F12' || code === 'F12') { e.preventDefault(); return false; }

      // Ctrl/Cmd + Shift + I/J/C/K/E/M
      //   I = inspector, J = console, C = element picker (all browsers)
      //   K = console, E = network, M = responsive mode (Firefox)
      if (ctrlOrCmd && e.shiftKey && isOneOf(['i', 'j', 'c', 'k', 'e', 'm'])) {
        e.preventDefault(); return false;
      }

      // macOS Safari/Chrome use Cmd + Option(alt) + I/J/C/U
      if (e.metaKey && e.altKey && isOneOf(['i', 'j', 'c', 'u'])) {
        e.preventDefault(); return false;
      }

      // Ctrl/Cmd + U (view source), S (save page), P (print)
      if (ctrlOrCmd && isOneOf(['u', 's', 'p'])) {
        e.preventDefault(); return false;
      }
    }, true);
  }

  // Module scripts are deferred, but guard anyway so it works regardless of
  // how/when the file is loaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();





// =-----------------------------------------------------------------------------------

(function ($) {
  'use strict';

  var timers = {};

  /* ---------------------------------------------------------------- Countdown */

  // 1. Turn the "YYYY-MM-DD HH:MM" setting into a timestamp. Returns null when unusable.
  function parseEnd(value) {
    if (!value) return null;

    var normalized = String(value).trim().replace(' ', 'T');
    if (normalized.indexOf('T') === -1) normalized += 'T00:00';

    var time = new Date(normalized).getTime();
    return isNaN(time) ? null : time;
  }

  // 2. Always render two digits, matching the design.
  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  // 3. Write the remaining time into each unit. Hours roll up when the days unit is absent.
  function render($timer, endTime) {
    var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    var hasDays = $timer.find('[data-unit="days"]').length > 0;

    var days = hasDays ? Math.floor(remaining / 86400) : 0;
    var hours = Math.floor(remaining / 3600) - days * 24;
    var minutes = Math.floor(remaining / 60) % 60;
    var seconds = remaining % 60;

    if (hasDays) $timer.find('[data-unit="days"]').text(pad(days));
    $timer.find('[data-unit="hours"]').text(pad(hours));
    $timer.find('[data-unit="minutes"]').text(pad(minutes));
    $timer.find('[data-unit="seconds"]').text(pad(seconds));

    return remaining;
  }

  // 4. Start one interval per timer and keep its id so the section can clean up.
  function initTimers(scope) {
    $('[data-friends-hero-timer]', scope).each(function () {
      var $timer = $(this);
      var endTime = parseEnd($timer.attr('data-end'));
      if (!endTime) return;

      var id = sectionId($timer);
      destroyTimer(id);

      if (render($timer, endTime) <= 0) {
        $timer.addClass('friends-hero__timer--expired');
        return;
      }

      timers[id] = setInterval(function () {
        if (render($timer, endTime) <= 0) {
          destroyTimer(id);
          $timer.addClass('friends-hero__timer--expired');
          $timer.trigger('friendsHero:expired');
        }
      }, 1000);
    });
  }

  function destroyTimer(id) {
    if (!timers[id]) return;
    clearInterval(timers[id]);
    delete timers[id];
  }

  /* ------------------------------------------------------------------- Video */

  // 5. Only the visible breakpoint's video is allowed to load and play, so the
  //    hidden one never costs the visitor any bandwidth.
  function syncVideos(scope) {
    $('[data-friends-hero-video]', scope).each(function () {
      var video = this;
      var visible = $(video).closest('.friends-hero__media').is(':visible');
      var autoplay = $(video).attr('data-autoplay') === 'true';

      if (visible && autoplay) {
        video.muted = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      } else if (!visible) {
        video.pause();
      }

      setToggleState(video);
    });
  }

  // 6. Keep the play / pause button in step with the video's real state.
  function setToggleState(video) {
    var $toggle = $(video).closest('.friends-hero__media').find('[data-friends-hero-video-toggle]');
    if (!$toggle.length) return;

    var playing = !video.paused;
    $toggle.toggleClass('friends-hero__video-toggle--playing', playing);
    $toggle.attr('aria-label', playing ? $toggle.attr('data-label-pause') : $toggle.attr('data-label-play'));
  }

  // 7. Bind the toggle. play / pause events do not bubble, so they are bound per video.
  function initVideos(scope) {
    $('[data-friends-hero-video]', scope).each(function () {
      var video = this;

      $(video).on('play.friendsHero pause.friendsHero', function () {
        setToggleState(video);
      });

      $(video)
        .closest('.friends-hero__media')
        .find('[data-friends-hero-video-toggle]')
        .on('click.friendsHero', function () {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
    });

    syncVideos(scope);
  }

  function destroyVideos(scope) {
    $('[data-friends-hero-video]', scope).off('.friendsHero');
    $('[data-friends-hero-video-toggle]', scope).off('.friendsHero');
  }

  /* ------------------------------------------------------------------ Lifecycle */

  function sectionId($el) {
    return $el.closest('.shopify-section').attr('id') || 'friends-hero';
  }

  function init(scope) {
    initTimers(scope);
    initVideos(scope);
  }

  $(document).ready(function () {
    init(document);
  });

  // 8. Re-check on resize so a breakpoint change swaps which video is running.
  var resizeTimeout;
  $(window).on('resize.friendsHero', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      syncVideos(document);
    }, 200);
  });

  $(document)
    .on('shopify:section:load.friendsHero', function (event) {
      init(event.target);
    })
    .on('shopify:section:unload.friendsHero', function (event) {
      destroyTimer($(event.target).attr('id'));
      destroyVideos(event.target);
    });
})(jQuery);

// ============================================================================

$(document).ready(function () {
  // 1. Mobile-first: slider runs by default, unslicks from tablet up
  var mq = window.matchMedia('(min-width: 750px)');
  var $slider = $('.notify-gallery__slider');

  // 2. Init on mobile, destroy on larger screens
  function toggleSlider() {
    if (mq.matches) {
      if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
      return;
    }

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots: true,
      });
    }
  }

  // 3. Run now + on breakpoint change
  toggleSlider();
  mq.addEventListener('change', toggleSlider);
});

// ============================================================================

$(document).ready(function () {
  $('.friends-gallery__list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 699,
        settings: { 
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });
});

// ============================================================================

$(document).ready(function () {
  $('.fun-facts__list')
    .on('init', function (event, slick) {
      applyNeighbours(slick, 0);
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      applyNeighbours(slick, nextSlide);
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 800,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)'
    });

  function applyNeighbours(slick, index) {
    slick.$slides
      .removeClass('prev-slide next-slide')
      .eq(index - 1).addClass('prev-slide').end()
      .eq(index + 1).addClass('next-slide');
  }
});

$(document).on("click", ".fun-facts__slide.next-slide .fun-facts__main", function () {
  $(this).closest(".fun-facts").find(".fun-facts__list .slick-next").trigger("click");
});

$(document).on("click", ".fun-facts__slide.prev-slide .fun-facts__main", function () {
  $(this).closest(".fun-facts").find(".fun-facts__list .slick-prev").trigger("click");
});

// =======================================================================================

(function ($) {
  'use strict';

  var GROUP = '[data-friends-marquee-group]';

  // 1. Rebuild one marquee: reset to a single group, then clone it until the track
  //    is wider than two screens. Without enough copies the strip would empty out
  //    on wide screens and the loop would visibly jump.
  function build(marquee) {
    var $marquee = $(marquee);
    var $track = $marquee.find('.friends-marquee__track');
    var $group = $track.find(GROUP).first();
    if (!$group.length) return;

    $track.find(GROUP).not($group).remove();

    var groupWidth = $group[0].getBoundingClientRect().width;
    var viewport = $marquee[0].getBoundingClientRect().width;
    if (!groupWidth || !viewport) return;

    var copies = Math.max(2, Math.ceil((viewport * 2) / groupWidth));

    for (var i = 1; i < copies; i++) {
      $group.clone().attr('aria-hidden', 'true').appendTo($track);
    }

    // 2. The keyframe moves the track by -100% / copies, which is exactly one group
    //    width, so the frame after the cycle ends is identical to the first one and
    //    the restart is invisible. Duration is derived from the speed setting so the
    //    pixels-per-second stay the same no matter how many copies were needed.
    var speed = parseFloat($marquee.attr('data-speed')) || 60;

    $track.css({
      '--friends-marquee-copies': copies,
      '--friends-marquee-duration': groupWidth / speed + 's'
    });
  }

  // 3. Images change the group's width once they load, so measure again after each one.
  function buildWhenReady(marquee) {
    build(marquee);

    $(marquee)
      .find('img')
      .each(function () {
        if (this.complete) return;
        $(this).one('load.friendsMarquee error.friendsMarquee', function () {
          build(marquee);
        });
      });
  }

  function init(scope) {
    $('[data-friends-marquee]', scope).each(function () {
      buildWhenReady(this);
    });
  }

  $(document).ready(function () {
    init(document);
  });

  // 4. Re-measure on resize, since the number of copies depends on the screen width.
  var resizeTimeout;
  $(window).on('resize.friendsMarquee', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      init(document);
    }, 200);
  });

  $(document)
    .on('shopify:section:load.friendsMarquee', function (event) {
      init(event.target);
    })
    .on('shopify:section:unload.friendsMarquee', function (event) {
      $('img', event.target).off('.friendsMarquee');
    });
})(jQuery);

// ===================================================================================================

(function ($) {
  'use strict';

  var tickers = {};

  // 1. Same rule Liquid used, so the server render and the script never disagree.
  function format(value, separator) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  // 2. The count is never "incremented" as such, it is always derived from the
  //    anchor. That is what makes a refresh, a throttled background tab and a
  //    day-old session all land on the same number.
  function countAt($number, nowMs) {
    var start = parseInt($number.attr('data-start'), 10);
    var startNumber = parseInt($number.attr('data-start-number'), 10) || 0;
    var interval = parseInt($number.attr('data-interval'), 10) || 1;

    var elapsed = Math.floor(nowMs / 1000) - start;
    if (elapsed < 0) elapsed = 0;

    return startNumber + Math.floor(elapsed / interval);
  }

  // 3. Repaint only when the value actually changes, and keep data-count in step.
  function paint($number, value) {
    if (parseInt($number.attr('data-count'), 10) === value) return;

    var separator = ',';
    var suffix = $number.attr('data-suffix') || '';

    $number.attr('data-count', value);
    $number.text(format(value, separator) + suffix);
  }

  function init(scope) {
    $('[data-friends-counter]', scope).each(function () {
      var $counter = $(this);
      var $number = $counter.find('.friends-counter__number');
      if (!$number.length) return;

      var id = $counter.closest('.shopify-section').attr('id') || 'friends-counter';
      destroy(id);

      // 4. The visitor's clock may be wrong or in another timezone, so measure the
      //    gap against the server's clock once and correct every reading by it.
      var serverNow = parseInt($number.attr('data-now'), 10) * 1000;
      var offset = serverNow - Date.now();

      tickers[id] = setInterval(function () {
        paint($number, countAt($number, Date.now() + offset));
      }, 1000);

      // 5. A backgrounded tab throttles timers, so re-derive as soon as it returns.
      $(document).on('visibilitychange.friendsCounter.' + id, function () {
        if (!document.hidden) paint($number, countAt($number, Date.now() + offset));
      });
    });
  }

  function destroy(id) {
    if (!tickers[id]) return;
    clearInterval(tickers[id]);
    delete tickers[id];
    $(document).off('visibilitychange.friendsCounter.' + id);
  }

  $(document).ready(function () {
    init(document);
  });

  $(document)
    .on('shopify:section:load.friendsCounter', function (event) {
      init(event.target);
    })
    .on('shopify:section:unload.friendsCounter', function (event) {
      destroy($(event.target).attr('id'));
    });
})(jQuery);

// ====================================================================
$(document).ready(function () {
  // 2. Click on the video -> show buttons on the parent media wrapper
  $(document).on('click.friendsHero', '.friends-hero__video', function () {
    var $media = $(this).closest('.friends-hero__media');

    $media.addClass('show-buttons');
    setTimeout(function () {
      $media.removeClass('show-buttons');
    }, 2000);
  });
});

// =======================================================================================

// function openPopup() {
//   $popup.addClass('is-open');
//   $('html').addClass('notify-popup-open');
// }

// function closePopup() {
//   $popup.removeClass('is-open');
//   $('html').removeClass('notify-popup-open');
// }

// // Open / close
// $('body').on('click.notifyPopup', '[data-notify-me-btn]', function (e) {
//   e.preventDefault();
//   openPopup();
// });

// $popup.on('click.notifyPopup', '[data-notify-popup-close]', function (e) {
//   e.preventDefault();
//   closePopup();
// });

// // Click on the overlay (outside the panel) closes it
// $popup.on('click.notifyPopup', function (e) {
//   if (e.target === this) closePopup();
// });

// $(document).on('keydown.notifyPopup', function (e) {
//   if (e.key === 'Escape' && $popup.hasClass('is-open')) closePopup();
// });

$(document).on('click', '.notifyme-opner', function (e) {
  e.preventDefault();
  $('.notify-popup').removeClass('is-success'); 
  $('.notify-popup').addClass('is-open'); 
  $('html').addClass('notify-popup-open')
});
$(document).on('click', '.notify-popup__close', function (e) {
  e.preventDefault();
  $('html').removeClass('notify-popup-open')
  $('.notify-popup').removeClass('is-open '); 
  setTimeout(() => {
      $('.notify-popup').removeClass('is-success'); 
  }, 500);
});

$(document).on('click', '.notify-me-products-product-list--item_wrapper', function (e) {
  var isMobile = window.matchMedia('(max-width: 767px)');
  if (!isMobile.matches) return;
  e.preventDefault();
  $('.notify-popup').removeClass('is-success').addClass('is-open');
  $('html').addClass('notify-popup-open');
});




// // ======================================================================================
(function ($) {
  var $popup = $('[data-notify-popup]');
  var $form = $popup.find('[data-notify-popup-form]');
  var $error = $popup.find('[data-notify-popup-error]');
  var $submit = $popup.find('[data-notify-popup-submit]');

  function showError(message) {
    $error.text(message).prop('hidden', false);
  }

  function setBusy(isBusy) {
    $submit.attr('aria-busy', isBusy);
    $submit.prop('disabled', isBusy);
  }

  $form.on('submit', function (e) {
    e.preventDefault();
    $error.prop('hidden', true);

    var name = $popup.find('[data-notify-popup-name]').val();
    var phone = $popup.find('[data-notify-popup-phone]').val().replace(/\s/g, '');
    var email = $popup.find('[data-notify-popup-email]').val();
    var count = $('.friends-counter__number').attr('data-count');

    if (!name) {
      showError('Please enter your name.');
      return;
    }

    if (!/^[0-9]{10}$/.test(phone)) {
      showError('Please enter a valid 10 digit mobile number.');
      return;
    }

    if (!email) {
      showError('Please enter your email id.');
      return;
    }

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      showError('Please enter a valid email id.');
      return;
    }

    var formdata = {
      first_name: name,
      phone: '91' + phone,
      email: email,
      tag: 'friends_collection',
      waitlist_no: count
    };

    console.log('Sending:', formdata);

    $.ajax({
      url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
      method: "POST",
      contentType: "application/json",
      headers: {
        "Authorization": "970614a6802448fd87feb315a2fc121d"
      },
      data: JSON.stringify(formdata),
      beforeSend: function () {
        setBusy(true);
      },
      success: function (response) {
        console.log("response",response);
        if (response.waitlist_no != null) {
          $('[data-notify-popup-count]').text(`#${response.waitlist_no}`);
          $popup.addClass('is-success');
          $form[0].reset();
        }
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        showError('Something went wrong. Please try again.');
      },
      complete: function () {
        setBusy(false);
      }
    });
  });
})(jQuery);
// ============================================
$(document).on('click', '.m-byob_item-introtext--show-more-less-button', function () {
  const $button = $(this);
  const $text = $button.siblings('.m-byob_item-introtext--text');

  $text.toggleClass('show-all');

  $button.text($text.hasClass('show-all') ? 'Read Less' : 'Read More');
});

// ==========================================================================================================================================================

